module.exports = __webpack_public_path__ + "img/deposit.2b0682a0.png";